import React from 'react';
import { tv } from '@/utils/tv';
import { PageSpinner } from '@/components/Spinner/PageSpinner';
import { useGalleryImage } from '@/hooks/useGalleryImage';
import type { GalleryImageItem } from '@/types/gallery';

export const GALLERY_PREVIEW_THUMBNAIL_SIZE = 250;
export const GALLERY_GRID_THUMBNAIL_SIZE = 400;

interface Props {
  image: GalleryImageItem;
  size: number;
  className: string;
  overlayText?: string;
  onClick: () => void;
}

const thumbnail = tv({
  base: 'relative cursor-pointer overflow-hidden rounded-xl bg-muted',
});

export const GalleryThumbnail: React.FC<Props> = ({
  image,
  size,
  className,
  overlayText,
  onClick,
}) => {
  const url = useGalleryImage(image.id, size);

  return (
    <button
      type="button"
      onClick={onClick}
      className={thumbnail({ className })}
    >
      {url && (
        <img
          src={url}
          alt={image.fileName}
          draggable={false}
          className="size-full object-cover select-none"
        />
      )}
      {!url && (
        <span className="absolute inset-0 flex items-center justify-center">
          <PageSpinner />
        </span>
      )}
      {overlayText && (
        <span className="absolute inset-0 flex items-center justify-center bg-black/50 text-[26px]/[34px] font-semibold text-white">
          {overlayText}
        </span>
      )}
    </button>
  );
};
